import {Button} from "reactstrap";
import React from "react";
import "scss/steps.css"


export default class StepButton extends React.Component{
    render(){
        return <Button
            color={"primary"}
            {...this.props}
            className={"step_button " + this.props.className}
        >
            {this.props.children}
        </Button>
    }
}